import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './client.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Client } from "model/system/client.model";

export interface ClientDetailsProps extends DetailsStateAndDispatchProps<Client>,
  RouteComponentProps, StateProps, DispatchProps {
}
const ClientDetails: FC<ClientDetailsProps> = (props) => {
  return (
    <DetailsPage<Client>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Client>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ client }: RootState) => ({
  entity: client.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ClientDetails);
